import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BlogArticleDto, HomeApi, LandingStatsDto } from "api";

import { ApiError } from "types";

const homeApi = new HomeApi();

export interface HomeState {
  latestBlogArticles: BlogArticleDto[];
  statistics: LandingStatsDto;
}

const initialState: HomeState = {
  latestBlogArticles: [],
  statistics: {
    transactions: 0,
    users: 0,
    banks: 26,
    commission: 0,
  },
};

export const getLatestBlogArticles = createAsyncThunk<
  BlogArticleDto[],
  void,
  { rejectValue: ApiError }
>("home/getLatestBlogArticles", async (_, { rejectWithValue }) => {
  try {
    const { data } = await homeApi.homeBlogTopArticlesGet();

    return data;
  } catch (error) {
    const { response } = error as { response: ApiError };

    return rejectWithValue(response);
  }
});

export const getLandingStats = createAsyncThunk<
  LandingStatsDto,
  void,
  { rejectValue: ApiError }
>("home/getLandingStats", async (_, { rejectWithValue }) => {
  try {
    const { data } = await homeApi.homeLandingStatsGet();

    return data;
  } catch (error) {
    const { response } = error as { response: ApiError };

    return rejectWithValue(response);
  }
});

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLatestBlogArticles.fulfilled, (state, action) => {
        state.latestBlogArticles = action.payload;
      })
      .addCase(getLatestBlogArticles.rejected, (state) => {
        state.latestBlogArticles = [];
      })

      .addCase(getLandingStats.fulfilled, (state, action) => {
        state.statistics = action.payload;
      })
      .addCase(getLandingStats.rejected, (state) => {
        state.statistics = {
          transactions: 0,
          users: 0,
          banks: 0,
          commission: 0,
        };
      });
  },
});

export default homeSlice.reducer;
